import { render, staticRenderFns } from "./ValidateTSDetails.vue?vue&type=template&id=540c886d&scoped=true&"
import script from "./ValidateTSDetails.vue?vue&type=script&lang=js&"
export * from "./ValidateTSDetails.vue?vue&type=script&lang=js&"
import style0 from "./ValidateTSDetails.vue?vue&type=style&index=0&id=540c886d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540c886d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540c886d')) {
      api.createRecord('540c886d', component.options)
    } else {
      api.reload('540c886d', component.options)
    }
    module.hot.accept("./ValidateTSDetails.vue?vue&type=template&id=540c886d&scoped=true&", function () {
      api.rerender('540c886d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/validateTS/ValidateTSDetails.vue"
export default component.exports